export default class SopSimulatorResource {
    static menu = {
        SOP_빠른실행: "SOP 빠른실행",
        SOP_불러오기: "SOP 불러오기",
        SOP_실행: "SOP 실행",
        SOP_설정: "SOP 설정",
        SOP_요약: "SOP 요약",
        SOP_시작_옵션: "SOP 시작 옵션"
    }
}